import BaseTableDataConverter from "../table/BaseTableDataConverter";
import {ColumnsConfig} from "./ColumnsConfig";
import {RowType} from "../table/RowType";

export default class TableDataConverter extends BaseTableDataConverter {
    constructor(reportData, reportParams) {
        super(reportData, reportParams);
        this.hasTimeBalance = this.reportParams.columnsConfig !== ColumnsConfig.OVERTIME_ONLY;
        this.hasOvertime = this.reportParams.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY;
    }

    _createHeader() {
        return {
            type: RowType.HEADER,
            hasTimeBalance: this.hasTimeBalance,
            hasOvertime: this.hasOvertime
        }
    }

    _createDataRow(level, type, groupingType, item) {
        const workingTime = item["workingTime"];
        const leaveTime = item["leaveTime"];
        const scheduledTime = item["scheduled"];
        let reportedTime = null;
        let differenceTime = null;
        if (!_.isNull(workingTime) || !_.isNull(leaveTime)) {
            reportedTime = workingTime + leaveTime;
            differenceTime = reportedTime - scheduledTime;
        }

        return {
            type: type,
            id: item["id"],
            scheduledTime: scheduledTime,
            reportedTime: reportedTime,
            workingTime: workingTime,
            leaveTime: leaveTime,
            differenceTime: differenceTime,
            reportedOvertime: item["reportedOvertime"],
            autoOvertime: item["autoCalculatedOvertime"],
            hasTimeBalance: this.hasTimeBalance,
            hasOvertime: this.hasOvertime,
            isEmployed: item["employed"]
        };
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/TableDataConverter.js